// fr.js
export default {
  home: "Accueil",
  home_welcome: "Bienvenue sur le site web de ClubBabyPro",
  home_team_description: "Nous sommes un groupe d'étudiants en informatique, qui a décidé de développer des projets personnels pendant son temps libre. Vous découvrirez ici tous nos différents projets.",

  // Accueil / hero
  hero_tagline: "STUDIO DE JEUX INDÉPENDANT",
  hero_lead: "Nous créons des jeux mobiles simples à prendre en main, avec chacun leur propre univers. Découvrez Stellar Collect, notre idle clicker spatial, le jeu narratif Laowai Survival et notre jeu d’arcade Hot Pursuit.",
  hero_cta_discover: "DÉCOUVRIR STELLAR COLLECT",
  hero_cta_laowai: "VOIR LAOWAI SURVIVAL",
  hero_cta_hot_pursuit: "VOIR HOT PURSUIT",

  // Section projets
  projects_eyebrow: "Nos jeux",
  projects_title: "Ce qu'on crée",
  game_teaser: "Fuyez la police, semez les voitures de patrouille et survivez le plus longtemps possible dans une course-poursuite frénétique. Ramassez des crédits et débloquez de nouveaux véhicules.",
  laowai_new_game_label: "NOUVEAU JEU",
  laowai_card_text: "Survivez au quotidien en Chine dans un jeu narratif humoristique rempli de choix, d’imprévus et de malentendus culturels.",
  learn_more: "En savoir plus",

  // Page Hot Pursuit
  game_pitch: "Vous incarnez un driver traqué par la police dans les rues de la ville. Le but est simple : tenir le plus longtemps possible.",
  game_description_title: "Semez la police",
  game_description: "Pilotez à toute vitesse, esquivez les voitures de patrouille et survivez le plus longtemps possible dans cette course-poursuite frénétique.",
  game_customisation_title: "Collectez & débloquez",
  game_customisation: "Ramassez des crédits en conduisant dans la ville et débloquez de nouveaux véhicules depuis la boutique : voitures de sport, camions, bus…",
  download_title: "Prêt à prendre la fuite ?",
  download_sub: "Téléchargez Hot Pursuit gratuitement sur Google Play.",

  // Page Laowai Survival
  laowai_subtitle: "Un jeu mobile narratif humoristique sur les petites galères du quotidien en Chine.",
  laowai_pitch: "Incarnez un étranger qui tente de survivre aux petites galères du quotidien en Chine. À chaque événement, choisissez entre trois réactions et assumez les conséquences.",
  laowai_fact_android: "Disponible sur Android",
  laowai_fact_genre: "Narratif",
  laowai_fact_choices: "Choix A/B/C",
  laowai_fact_languages: "EN & FR",
  laowai_fact_localized: "Deux langues",
  laowai_fact_events: "événements illustrés",
  laowai_choices_eyebrow: "Choix",
  laowai_choices_title: "Trois réactions, une conséquence",
  laowai_choices_text: "Chaque situation propose des choix A/B/C. Vos décisions peuvent changer vos ressources, votre progression et votre capacité à tenir jusqu’au lendemain.",
  laowai_modes_eyebrow: "Modes",
  laowai_modes_title: "Deux façons de survivre",
  laowai_classic_title: "Classic Run",
  laowai_classic_text: "Survivez 15 jours aux imprévus du quotidien.",
  laowai_endless_title: "Endless Run",
  laowai_endless_text: "Continuez aussi longtemps que possible et visez le meilleur score.",
  laowai_content_eyebrow: "Contenu",
  laowai_content_title: "45 événements illustrés et un Word Guide",
  laowai_content_text: "Laowai Survival est disponible en anglais et en français. Le Word Guide aide à comprendre certains mots et situations liés à la vie en Chine.",
  laowai_services_title: "Jeu et services",
  laowai_services_items: [
    "Aucun compte requis",
    "Aucun achat intégré",
    "Aucun backend Club Baby Pro",
    "Classement Google Play Games optionnel pour Endless Run",
    "Revive par publicité récompensée facultative en Endless Run uniquement"
  ],
  laowai_services_note: "Le jeu reste entièrement jouable sans connexion Google Play Games et sans regarder de publicité.",
  laowai_internal_testing: "Disponible sur Android.",
  laowai_privacy_link: "Privacy Policy",
  laowai_hero_alt: "Illustration principale de Laowai Survival avec un étranger en Chine",
  laowai_icon_alt: "Icône de Laowai Survival",
  laowai_choice_alt: "Écran de choix A/B/C dans Laowai Survival",
  laowai_menu_alt: "Menu principal de Laowai Survival",
  laowai_result_alt: "Écran de conséquences après un événement dans Laowai Survival",

  // ---------- Stellar Collect ----------
  sc_new_game_label: "NOUVEAU JEU",
  sc_card_text: "Minez des astéroïdes au doigt, pilotez votre vaisseau dans la ceinture et transformez chaque tap en empire minier. Un idle clicker spatial en 3D low-poly, gratuit sur Android.",
  sc_subtitle: "Un idle clicker spatial en 3D low-poly. Tapez, minez, améliorez — même hors ligne.",
  sc_pitch: "Vous pilotez un vaisseau minier au doigt dans un couloir d'astéroïdes. Au départ, taper les roches est la seule façon de progresser : la tourelle automatique est une amélioration à acheter. Chaque minerai ramassé finance des drones, des coques plus puissantes et des rangs qui rendent le champ plus coriace — et plus rentable.",
  sc_fact_android: "Gratuit sur Android",
  sc_fact_genre: "Idle / Clicker",
  sc_fact_genre_sub: "Une main, format portrait",
  sc_fact_languages: "FR · EN · ES",
  sc_fact_localized: "Entièrement traduit",
  sc_fact_ranks: "24",
  sc_fact_ranks_sub: "rangs à gravir",

  sc_tap_eyebrow: "Le geste",
  sc_tap_title: "Un clicker avant d'être un idle",
  sc_tap_text: "Tant que la tourelle automatique n'est pas achetée, chaque astéroïde détruit l'est par vos taps. C'est ce qui donne du poids à la première grosse amélioration : l'automatisation ne vaut que pour un joueur qui a d'abord joué sans elle.",
  sc_pilot_eyebrow: "Le pilotage",
  sc_pilot_title: "Glissez pour aller chercher le minerai",
  sc_pilot_text: "Les fragments ne viennent pas seuls : le rayon de votre aimant reste volontairement plus petit que la largeur du couloir. Glissez le doigt n'importe où pour amener le vaisseau sur la récolte, esquivez, et laissez vos drones d'escorte mitrailler pendant ce temps.",
  sc_progress_eyebrow: "Progression",
  sc_progress_title: "Cinq améliorations, huit coques, vingt-quatre rangs",
  sc_progress_text: "Puissance de tir, tourelle, aimant, drones et multiplicateur : chaque niveau se voit à l'écran. La matière noire, plus rare, ouvre le garage — de l'Éclaireur MK-I à la Foreuse Abyssale — pendant que les rangs durcissent les roches et augmentent vos gains.",
  sc_idle_eyebrow: "Hors ligne",
  sc_idle_title: "Vos drones travaillent sans vous",
  sc_idle_text: "Fermez le jeu : les drones continuent de récolter, jusqu'à huit heures. Vous retrouvez le butin au retour, avec une prime quotidienne et des boosts temporaires à déclencher quand vous voulez pousser une session.",

  sc_services_title: "Jeu et services",
  sc_services_items: [
    "Aucun compte requis",
    "Aucun achat intégré",
    "Aucun serveur Club Baby Pro : la partie est sauvegardée sur l'appareil",
    "Jouable hors connexion",
    "Français, anglais et espagnol",
    "Publicités récompensées facultatives"
  ],
  sc_services_note: "Le jeu est entièrement jouable sans regarder la moindre publicité.",
  sc_download_title: "Prêt à miner ?",
  sc_download_sub: "Stellar Collect est gratuit sur Google Play.",
  sc_privacy_link: "Politique de confidentialité",
  sc_hero_alt: "Vaisseau minier et drones d'escorte dans un champ d'astéroïdes",
  sc_icon_alt: "Icône du jeu Stellar Collect",
  sc_shot_game_alt: "Le vaisseau et ses drones minent un astéroïde dans Stellar Collect",
  sc_shot_upgrades_alt: "Écran des améliorations de Stellar Collect",
  sc_shot_garage_alt: "Garage et coques disponibles dans Stellar Collect",
  sc_shot_ranks_alt: "Chemin des vingt-quatre rangs de Stellar Collect",
}
